import { createLocale } from "./createLocale";

export const da = createLocale({
  header: {
    title: "Gå globalt. 2 $ pr. Short. Ethvert sprog!",
    subtitle: "🔥Betal kun for resultater – fra $0.089 til $0.009 pr. sekund🔥",
  },
  steps: {
    uploadVideo: "Upload video",
    selectLanguages: "Vælg sprog",
    conversionResult: "Konvertering og resultat",
  },
  upload: {
    dragAndDrop: "Træk og slip din videofil her",
    orClickToSelect: "eller klik for at vælge",
    supportedFormats: "Understøttede formater: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maksimal filstørrelse: 200 MB",
    maxDuration: "• Maksimal varighed: 30 sek",
    chooseFile: "Vælg fil",
    selectedFile: "Valgt fil:",
    size: "Størrelse:",
    fileTypeError: "Vælg venligst en videofil",
    fileSizeError: "Filstørrelsen ({size} MB) overstiger den maksimale grænse på 200 MB",
    durationError: "Videovarigheden ({duration} sek) overstiger den maksimale grænse på 30 sek",
    fileReadError: "Kunne ikke læse videofilen. Prøv venligst en anden fil.",
  },
  languages: {
    sourceAudioLanguage: "Kildesprogets lyd",
    targetAudioLanguage: "Målsprogets lyd",
    selectLanguage: "Vælg sprog...",
  },
  conversion: {
    replaceAudio: "Klon min stemme",
    uploadVideoAndSelectLanguages: "Upload en video, og vælg sprog for at fortsætte",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Privatlivspolitik",
    termsOfUse: "Brugsvilkår",
  },
  languageOptions: {
    da: "Dansk",
  },
});
